// extracted by mini-css-extract-plugin
module.exports = {"captcha_disclaimer":"_captcha_captcha_disclaimer__OYQ48","captcha_error":"_captcha_captcha_error__gdvgQ"};